import Maintenance from "../../global/Maintenance";

const UploadFiles = () => {
    return ( 
        <Maintenance/>
     );
}
 
export default UploadFiles;